<div [formGroup]="formGroup">
	<div class="field-row label-width-50">
		<div class="field-row-title">Vehicle ID</div>
		<div class="field-row-element">
			<mat-form-field class="w-100" subscriptSizing="dynamic">
				<input matInput
					   formControlName="name"
					   cdkFocusInitial
					   required>
				@if (formGroup.controls.name.hasError('required')) {
					<mat-error>
						Vehicle ID is required.
					</mat-error>
				}
				@if (formGroup.controls.name.hasError('notUnique')) {
					<mat-error>
						Vehicle ID is already taken.
					</mat-error>
				}
				@if (formGroup.controls.name.pending) {
					<mat-progress-spinner diameter="20" mode="indeterminate" matSuffix>check</mat-progress-spinner>
				}
			</mat-form-field>
		</div>
	</div>
	@if (!showJustRequiredFields()) {
		<div class="field-row label-width-50 align-items-center">
			<div class="field-row-title">
				Alias
				<div>An alternative name to for this vehicle</div>
			</div>
			<div class="field-row-element">
				<mat-form-field class="w-100" subscriptSizing="dynamic">
					<input matInput formControlName="label">
					@if (formGroup.controls.label.hasError('notUnique')) {
						<mat-error>
							Vehicle Label is already being used.
						</mat-error>
					}
					@if (formGroup.controls.label.pending) {
						<mat-progress-spinner diameter="20" mode="indeterminate" matSuffix>check</mat-progress-spinner>
					}
				</mat-form-field>
			</div>
		</div>
		<div class="field-row label-width-50 align-items-center">
			<div class="field-row-title">
				Public Portal Alias
				<div>Name that appears on public portal</div>
			</div>
			<div class="field-row-element">
				<mat-form-field class="w-100" subscriptSizing="dynamic">
					<input matInput formControlName="publicAlias">
					@if (formGroup.controls.publicAlias.hasError('notUnique')) {
						<mat-error>
							Public Alias is already being used.
						</mat-error>
					}
					@if (formGroup.controls.publicAlias.pending) {
						<mat-progress-spinner diameter="20" mode="indeterminate" matSuffix>check</mat-progress-spinner>
					}
				</mat-form-field>
			</div>
		</div>
		<div class="field-row label-width-50 align-items-center">
			<div class="field-row-title">
				License Plate
				<div>The vehicle license plate</div>
			</div>
			<div class="field-row-element">
				<mat-form-field class="w-100" subscriptSizing="dynamic">
					<input matInput formControlName="licensePlate">
					@if (formGroup.controls.licensePlate.hasError('notUnique')) {
						<mat-error>
							License Plate is already being used.
						</mat-error>
					}
					@if (formGroup.controls.licensePlate.pending) {
						<mat-progress-spinner diameter="20" mode="indeterminate" matSuffix>check</mat-progress-spinner>
					}
				</mat-form-field>
			</div>
		</div>
		<div class="field-row label-width-60 align-items-center">
			<div class="field-row-title">
				Vehicle Status
				<div>Out of service vehicles cannot be used to start shifts</div>
			</div>
			<div class="field-row-element">
				<mat-form-field subscriptSizing="dynamic">
					<mat-select formControlName="active" #statusSelect>
						<mat-option [value]="true">In Service</mat-option>
						<mat-option [value]="false">Out Of Service</mat-option>
					</mat-select>
				</mat-form-field>
			</div>
		</div>
    @if (!this.formGroup.controls['active'].value) {
      <div class="indent">
        <div class="field-row label-width-49 align-items-center">
          <div class="field-row-title">
            Note on Out-of-Service
          </div>
          <div class="field-row-element">
            <mat-form-field class="w-100" subscriptSizing="dynamic">
              <input matInput formControlName="outOfServiceNote">
              @if (formGroup.hasError('outOfServiceNoteMissing') || formGroup.controls.outOfServiceNote.hasError('required')) {
                <mat-error>
                  Note is required
                </mat-error>
              }
            </mat-form-field>
          </div>
        </div>
      </div>
    }
	}
	<div class="field-row label-width-60 align-items-center">
		<div class="field-row-title">
			Reporting Metrics
			<div>Does the vehicle uses odometer or hour meter?</div>
		</div>
		<div class="field-row-element">
			<mat-form-field subscriptSizing="dynamic">
				<mat-select formControlName="reportingType">
					<mat-option [value]="ReportingType.DISTANCE">Odometer</mat-option>
					<mat-option [value]="ReportingType.TIME">Time</mat-option>
				</mat-select>
			</mat-form-field>
		</div>
	</div>
	@if (!showJustRequiredFields()) {
		<app-row-with-toggle primaryText="Override Default GPS Track Color"
							 formControlName="mapColorOverride">
		</app-row-with-toggle>
		@if(formGroup.controls.mapColorOverride.value) {
      <div class="indent">
        <app-row-with-toggle primaryText="Apply Override Color to the Mobile App"
                             formControlName="applyColorOverrideOnMobile">
        </app-row-with-toggle>

				<div class="field-row align-items-center">
					<div class="field-row-title">
						GPS Track Color
					</div>
					<div class="field-row-element flex-column align-items-end">
						<ngx-colors ngx-colors-trigger
									colorPickerControls="no-alpha"
									colorsAnimation="popup"
									format="hex"
									formControlName="mapColor">
						</ngx-colors>
						@if (formGroup.hasError('mapColorMissing') || formGroup.controls.mapColor.hasError('required')) {
							<mat-error>
								GPS Track Color is required
							</mat-error>
						}
					</div>
				</div>
			</div>
		}
	}
</div>
